import { LOGOUT_URL } from './constants';

export const DEFAULT_ROUTE = '/';
export const HOME_ROUTE = '/home';
export const COURSE_DETAIL_ROUTE = '/course/:id';
export const PROFILE_ROUTE = '/profile';
export const TRANSCRIPT_ROUTE = '/transcript';
export const ACCESS_DENIED_ROUTE = '/accessdenied';
export const SIGN_OUT_ROUTE = `/signOut?redirect_uri=${LOGOUT_URL}`;
export const PAGE_NOT_FOUND_ROUTE = '/notFound';
export const MATCH_ALL_ROUTE = '*';

/** Id of the Class content tab on the course detail page. */
export const CLASS_CONTENT_TAB_ID = 'class-content';

/**
 * React Router location state the course detail page understands.
 *
 * `activeTabId` preselects a tab. Passed as navigation state rather than a query param so the tab
 * choice stays out of the URL — it is a hint from the page you came from, not part of the course's
 * address. It therefore does not survive a reload or a link opened in a new tab, both of which land
 * on the default tab. An id that names a tab which is not rendered is ignored.
 */
export interface CourseDetailLocationState {
    activeTabId?: string;
}

/**
 * Builds a course detail path. Derived from `COURSE_DETAIL_ROUTE` so the route and the links to it
 * cannot drift. Pair with `CourseDetailLocationState` to preselect a tab.
 */
export const courseDetailPath = (courseId: string): string => COURSE_DETAIL_ROUTE.replace(':id', courseId);
